import { useEffect, useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { loadCustomDashboardsOptions } from '../../redux/action';
import { useDispatch, useSelector } from 'react-redux';
import { MultiSelect } from "react-multi-select-component";

const SlaCustomDashboard = ({ selectedGraphs, setSelectedGraphs }) => {

    let dispatch = useDispatch();
    const { customDashboardOptions } = useSelector((state) => state.data);

    useEffect(() => {
        dispatch(loadCustomDashboardsOptions(6));
    }, []);

    return (
        <div>
            <Row className="pt-2">
                <Col>
                    <MultiSelect
                        options={customDashboardOptions || []}
                        value={selectedGraphs}
                        onChange={setSelectedGraphs}
                        labelledBy="Select Graphs"
                    />
                </Col>
            </Row>
        </div>
    );
};

export default SlaCustomDashboard;
